import React, { useEffect } from 'react'
import Dialog from '@material-ui/core/Dialog';
import Button from '@material-ui/core/Button';
import "./Reject.scss"


function Reject() {

  const homePage = () => {
    window.location.replace('/');
  };

  return (
    <Dialog
      open={true}
      className="error-dialog"

      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description">
      <div className="dialog-content">
      <h2 style={{ textAlign: 'center' }}>Pengaktifan profil gagal</h2>
        <p>
        Maaf! Pendaftaran akaun Rakan anda tidak berjaya kerana anda tidak memenuhi syarat kelayakan semasa kami. Kami berterima kasih atas minat anda dan harap anda dapat sertai komuniti Kongsi Klub kami pada masa hadapan.
        </p>
        <Button variant="contained" className="btn-dialog-loading" disabled={false} onClick={homePage}>
        Log keluar
        </Button>
      </div>
    </Dialog >
  )
}

export default Reject